import React from "react";
import home from "../content/home.json";

const PhilosophySection = () => {
  const { philosophy } = home;
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="py-20 md:py-24 bg-ivory"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
          {philosophy.overline}
        </p>
        <h2 className="mt-6 font-heading font-normal text-charcoal text-4xl sm:text-5xl md:text-6xl leading-[1.08] tracking-tight">
          {philosophy.headline}
          <span className="italic text-charcoal-soft">
            {philosophy.headlineItalic}
          </span>
        </h2>
        <div className="mt-8 mx-auto w-12 h-px bg-muted_gold" />
        <p className="mt-8 max-w-3xl mx-auto text-charcoal-soft text-lg md:text-xl leading-relaxed">
          {philosophy.body}
        </p>
      </div>
    </section>
  );
};

export default PhilosophySection;
